import { PawPrint } from 'lucide-react';

/**
 * Selector múltiple de mascotas (chips toggleables).
 *
 * Recibe `pets` activas del hogar y `selectedIds`. Llama a `onChange` con el
 * array nuevo cuando el usuario toca un chip.
 *
 * Si no hay pets activas, muestra hint para crear una primero.
 */
const PetMultiSelector = ({ pets = [], selectedIds = [], onChange, error, disabled = false }) => {
  if (pets.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-4 text-center">
        <PawPrint className="mx-auto h-6 w-6 text-slate-400" aria-hidden="true" />
        <p className="mt-2 text-sm text-slate-600">
          No hay mascotas activas. Creá una antes de agendar una cita.
        </p>
      </div>
    );
  }

  const toggle = (petId) => {
    if (disabled) return;
    const next = selectedIds.includes(petId)
      ? selectedIds.filter((id) => id !== petId)
      : [...selectedIds, petId];
    onChange(next);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {pets.map((pet) => {
          const isSelected = selectedIds.includes(pet.id);
          return (
            <button
              key={pet.id}
              type="button"
              onClick={() => toggle(pet.id)}
              disabled={disabled}
              aria-pressed={isSelected}
              className={[
                'inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors',
                isSelected
                  ? 'border-brand-500 bg-brand-50 text-brand-800'
                  : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50',
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
              ].join(' ')}
            >
              <PawPrint className="h-3.5 w-3.5" aria-hidden="true" />
              {pet.name}
            </button>
          );
        })}
      </div>
      {error && (
        <p role="alert" className="mt-1.5 text-sm text-status-red">
          {error}
        </p>
      )}
    </div>
  );
};

export default PetMultiSelector;
